import { createReducer, on } from '@ngrx/store';

import {
  fetchUpsellOptionsErrorAction, fetchPackageUpsellOptionsErrorAction, fetchUpsellOptionsAction,
  fetchPackageUpsellOptionsAction, resetUpsellAction, fetchUpsellOptionsErrorBySectorAction
} from '@upsell/store/actions/upsell.actions';

export const initialState = null;

export const clickedUpsellReducer = createReducer(
  initialState,
  on(
    resetUpsellAction,
    fetchPackageUpsellOptionsErrorAction,
    fetchUpsellOptionsErrorAction,
    fetchUpsellOptionsErrorBySectorAction,
    () => initialState
  ),
  on(fetchUpsellOptionsAction, (state, { optionId }) => optionId),
  on(fetchPackageUpsellOptionsAction, (state, { payload }) => payload?.optionIdAir),
);
